import { GestureHandlerRootView } from "react-native-gesture-handler";
import { LogBox, Platform } from "react-native";
import { StatusBar } from "expo-status-bar";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import AppLoader from "./AppLoader";
import GraphqlProvider from "./src/components/GraphqlProvider";
import ThemeProvider from "./src/components/ThemeProvider";
import { UserProvider } from "./src/hooks/useCurrentUser";
import { SnackBarProvider } from "./src/hooks/useSnackBar";
import NavigatorScreen from "./src/screens/NavigatorScreen";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { FeatureFlagProvider } from "./src/hooks/useFlagr";
import DataDogProvider from "./src/components/DatadogProvider";
import AmplitudeProvider from "./src/components/AmplitudeProvider";

LogBox && LogBox.ignoreLogs(["Non-serializable values were found in the navigation state"]);

if (__DEV__) {
  if (Platform.OS !== "web") {
    require("./ReactotronConfig");
  }
  loadDevMessages();
  loadErrorMessages();
}

export default function App() {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <SafeAreaProvider>
        <UserProvider>
          <AppLoader>
            <GraphqlProvider>
              <FeatureFlagProvider>
                <DataDogProvider>
                  <ThemeProvider>
                    <AmplitudeProvider>
                      <SnackBarProvider>
                        <NavigatorScreen />
                      </SnackBarProvider>
                    </AmplitudeProvider>
                    <StatusBar style="auto" />
                  </ThemeProvider>
                </DataDogProvider>
              </FeatureFlagProvider>
            </GraphqlProvider>
          </AppLoader>
        </UserProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}
